import React from "react";
import { FaArrowDown, FaArrowRight } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import "./SalesPageNew.css";

function CheckCircleOutline() {
   return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FF8E53" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
         <circle cx="12" cy="12" r="10" />
         <path d="m9 12 2 2 4-4" />
      </svg>
   );
}

export default function OutcomePromise({ windowWidth }) {
   const { t } = useTranslation();
   const isMobile = windowWidth < 640;
   const isMd = windowWidth >= 768;
   const steps = [t('salesPageNew.outcome.step1'), t('salesPageNew.outcome.step2'), t('salesPageNew.outcome.step3')];
   return (
      <section id="agents-section" style={{ maxWidth: 1152, margin: '0 auto', padding: '48px 24px', scrollMarginTop: 80 }}>
         <div style={{
            borderRadius: 24, border: '1px solid #FFD8B8', padding: isMobile ? 32 : 40,
            background: 'linear-gradient(180deg, #FFF6EE, #FFFFFF)', textAlign: 'center',
         }}>
            <p className="sp-eyebrow">{t('salesPageNew.outcome.eyebrow')}</p>
            <h2 style={{
               marginTop: 12, fontSize: windowWidth < 380 ? 36 : (isMd ? 60 : 48), letterSpacing: '-0.02em', color: 'var(--sp-ink)',
            }}>
               {t('salesPageNew.outcome.headingStart')}{" "}
               <span className="sp-accent-italic-agent">{t('salesPageNew.outcome.headingAccent')}</span>
               {" "}{t('salesPageNew.outcome.headingEnd')}
            </h2>
            <p style={{
               margin: '16px auto 0', maxWidth: 448, color: 'var(--sp-text-soft)', fontSize: 16,
               lineHeight: 1.7, textTransform: 'none', fontWeight: 400,
            }}>
               {t('salesPageNew.outcome.description')}
            </p>

            {/* Steps */}
            <div style={{
               marginTop: 32, display: 'flex', flexDirection: isMobile ? 'column' : 'row',
               alignItems: 'center', justifyContent: 'center', gap: 12, flexWrap: 'wrap',
            }}>
               {steps.map((s, i) => (
                  <div key={s} style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center', gap: 12 }}>
                     <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 8, borderRadius: 9999,
                        border: '1px solid #FFD8B8', background: '#fff', padding: '8px 16px',
                        fontSize: 14, fontWeight: 600, color: 'var(--sp-ink)', textTransform: 'none',
                     }}>
                        <CheckCircleOutline />
                        {s}
                     </span>
                     {i < steps.length - 1 && (
                        isMobile ? (
                           <FaArrowDown style={{ width: 14, height: 14, color: 'var(--sp-text-muted)' }} />
                        ) : (
                           <FaArrowRight style={{ width: 14, height: 14, color: 'var(--sp-text-muted)' }} />
                        )
                     )}
                  </div>
               ))}
            </div>
         </div>
      </section>
   );
}
